export const getError = state => state.fullscreen.get('error')
export const getIsSubmitting = state => state.fullscreen.get('isSubmitting')
